import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    uuid: String,
    interval: { type: Number, default: 5000 },
    mediaType: String,
  }

  declare uuidValue: string
  declare intervalValue: number
  declare mediaTypeValue: string

  private timer: number | null = null

  connect(): void {
    this.poll()
  }

  disconnect(): void {
    this.stop()
  }

  private poll(): void {
    this.timer = window.setInterval(() => {
      this.checkStatus()
    }, this.intervalValue)
  }

  private stop(): void {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  private checkStatus(): void {
    fetch(`/api/v2/detect/${this.uuidValue}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success && data.item) {
          let hasProcessed = false

          if (this.mediaTypeValue === 'video') {
            hasProcessed = !!(data.item.metrics?.label && data.item.video_metrics?.label)
          } else if (this.mediaTypeValue === 'image') {
            hasProcessed = !!data.item.image_metrics
          } else {
            hasProcessed = !!data.item.metrics?.label
          }

          if (hasProcessed || data.item.error_message) {
            this.stop()
            window.location.reload()
          }
        }
      })
      .catch((error) => {
        console.error('Error polling detect status:', error)
      })
  }
}
